import { useTranslation } from 'next-i18next'
import { css } from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { ColorCard, Description, Text } from './elements'

const smallText = css`
  @media (max-width: ${breakpoints.phoneMax}) {
    margin: 0;
    font-size: 21px;
    line-height: 18px;
  }
`

const smallDesc = css`
  @media (max-width: ${breakpoints.phoneMax}) {
    font-size: 27.5px;
    line-height: 32px;
    letter-spacing: -0.03px;
    padding-top: 70px;
    max-width: none;
  }
`

const MultiLayeredSecurity = () => {
  const { t } = useTranslation()
  return (
    <ColorCard color="#fe837b">
      <Text color={colors.white} customStyle={smallText}>
        {t('renters:Protecting your privacy')}
      </Text>
      <Description color={colors.white} alwaysLarge customStyle={smallDesc}>
        {t(
          'renters:Rent with peace of mind knowing all data, documents, and transactions are safe behind our multi-layered security and encryption protocols.'
        )}
      </Description>
    </ColorCard>
  )
}

export default MultiLayeredSecurity
